// قائمة اللغات المدعومة في التطبيق
export const locales = ["ar", "en"] as const;

// اللغة الافتراضية
export const defaultLocale = "ar" as const;

// استخدم هذا النوع في مكان آخر
export type Locale = (typeof locales)[number];
